import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export function DeadlineDialog({ initial, onClose, onSaved }) {
  const [hws, setHws] = useState([]);
  const [hwId, setHwId] = useState("");
  const [date, setDate] = useState("");
  useEffect(() => {
    if (!initial) return;
    setHwId(initial.homework_id || ""); setDate(initial.date || "");
    api.get("/homework").then((r) => setHws(r.data.filter((h) => h.status === "released")));
  }, [initial]);
  if (!initial) return null;
  const save = async (value) => {
    if (!hwId) return toast.error("Choose a homework.");
    if (value && !/^\d{4}-\d{2}-\d{2}$/.test(value)) return toast.error("Choose a due date.");
    try {
      await api.put(`/homework/${hwId}/due-date`, { due_date: value });
      toast.success(value ? "Deadline saved." : "Deadline removed."); onSaved();
    } catch (e) { toast.error(e.response?.data?.detail || "Could not save deadline."); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="mn max-w-md" data-testid="deadline-dialog">
        <DialogHeader><DialogTitle className="text-xl font-extrabold">Homework deadline</DialogTitle></DialogHeader>
        <p className="text-xs text-[#6B6488]">Only students assigned to this homework will see the deadline.</p>
        <div className="space-y-3">
          <div><Label>Homework</Label>
            <Select value={hwId} onValueChange={setHwId} disabled={!!initial.homework_id}>
              <SelectTrigger data-testid="deadline-homework-select" className="mt-1.5 h-11 rounded-xl"><SelectValue placeholder="Choose released homework" /></SelectTrigger>
              <SelectContent>{hws.map((h) => <SelectItem key={h.id} value={h.id}>{h.program_name?.split(" ")[0]} · {h.title}</SelectItem>)}</SelectContent>
            </Select></div>
          <div><Label>Due date</Label><Input type="date" data-testid="deadline-date-input" value={date} onChange={(e) => setDate(e.target.value)} className="mt-1.5 h-11 rounded-xl" /></div>
        </div>
        <DialogFooter className="gap-2 sm:justify-between">
          {initial.homework_id ? <Button variant="outline" onClick={() => save(null)} data-testid="deadline-remove-btn" className="rounded-xl border-rose-200 text-rose-600 hover:bg-rose-50">Remove deadline</Button> : <span />}
          <Button onClick={() => save(date)} data-testid="deadline-save-btn" className="rounded-xl ember-gradient font-bold">Save deadline</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
